// JavaScript Document
//components/configuration/ph5/Messages
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Button, ButtonGroup, Grid } from '@material-ui/core';

//utilities
import Utils from './Utils';
//Custom Component Imports
import Canvas from '../display/canvas/Canvas';
import Display from '../display/Display';
import Selector from '../display/message/Selector';

const utils = Utils();


const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
	pos: {
		marginBottom:12,
	},
	displayList : {
		marginTop:38
	},
	displaySelectMenu : {
		minWidth: 220,
	},

}));

export default function Ph5Messages(props) {
  	const classes = useStyles();
  	const {sign, messages, config, user, handleSend, loadedToken, onChange} = props;
	const [selected, setSelected] = React.useState(0);
	//local version of messages
	const [displays, setDisplays] = React.useState([]);
	//currently-selected message
	const [message, setMessage] = React.useState({
		id: 0,
		map: ''
	});
	const [messageList, setMessageList] = React.useState([]);
	const [loaded, setLoaded] = React.useState(false);
	const [token, setToken] = React.useState(0);
	const [size, setSize] = React.useState([4, 2]);
	const [rotate, setRotate] = React.useState(false);

	const [id, setId] = React.useState(0);
	
	const handleSelect = (num) => {
		if(displays){
			if(displays.length > num){
				console.log('we have displays');
				console.log(displays);
				setMessage(displays[num]);
			}
		}
		setSelected(num);
	} 

	
	//save new map to server
	const handleApply = (newmap) => {
		//get the new pixel map and save changes
		//console.log(newmap);
		var msg = Object.assign({}, message);
		msg.map = utils.message.compile(newmap, size[0], size[1], rotate);
		console.log(msg.map);
		
		handleSend({
			vso: 'ph5_message',
			subaction: 'save',
			message : msg
		}, (data) => {
			//let newConfig = Object.assign({}, myConfig);
			
			let newDisplays = Object.assign([], displays);
			let newMessage = Object.assign(data.message, {message: data.message.id, id:message.id});
			newDisplays.splice(selected, 1, newMessage);
			console.log(data);
			console.log(newMessage);

			//refresh the list of messages
			setLoaded(false);
			setDisplays(newDisplays);
			setMessage(newMessage);
			if(onChange){
				onChange(newDisplays);
			}
			
		})
		
		
	}
	
	//get list of compatible messages
	const get_messages = () => {
		if(sign.id){
			setLoaded(true);
			handleSend({
				vso: 'ph5_config',
				sign: sign,
				subaction: 'message_list'
			
			}, (data) => {
				
				setMessageList(data.config.message_list);
			});
		}
	}

	
	const handleSelectMessage = (selmsg) => {
		//console.log(e);
		//let selmsg = msg || msgPop.message;
		var newDisplays = Object.assign([], displays);
		let newMessage = Object.assign(selmsg, {id: (newDisplays.length < 6 ? 0 : displays[selected].id), message: selmsg.id, sign: sign.id});
		if(newDisplays.length === 6){
			newDisplays.splice(selected, 1, newMessage);
		} else {
			newDisplays.push(newMessage);
			setSelected(newDisplays.length -1);
		}
		setDisplays(newDisplays);
		setMessage(newMessage);
		//closePop();
		if(onChange)
			onChange(newDisplays);
	}


	const handleDelete = (message) => {
		handleSend({
			vso: 'ph5_message',
			subaction: 'delete',
			message : message
		}, (data) => {
			let msgList = Object.assign([], messageList);
			//remove deleted message from list
			msgList.splice(msgList.findIndex((msg) => msg.id === message.id), 1);
			//update message list
			setMessageList(msgList);
		
		});
	}
	
	
	//refresh
	React.useEffect(() => {
		//if(config){
		//	console.log('we have a config (useEffect)');
		var isRotated = false;
		if(config){
			//get rotation
			//console.log('messages config');
			//console.log(config);
			var rotateSetting = config.filter(i => i.name === 'DisplayRotation')[0];
			//console.log(rotateSetting);
			if(rotateSetting.value === 'ON')
				isRotated = true;
			setRotate(isRotated);
			//console.log('rotated is '+isRotated);
			if(sign){
				if(sign.itswidth && sign.itsheight){
					if(isRotated){
						setSize([sign.itsheight, sign.itswidth]);
					} else {
						setSize([sign.itswidth, sign.itsheight]);
					}
				}
			}
		}
			if(
				//inherited config ID is null
				id === 0 || 
				id === undefined || 
				id === null || 
				id === "0" || 
				//inherited daysetting has changed
				id !== sign.id 
				//updated from server
				|| loadedToken !== token
			) {
				console.log('sign has changed');
				//refresh from new config loaded
				
				setId(sign.id);
				if(messages){
					console.log('we have messages (useEffect)');
					console.log(messages);
					setDisplays(messages);
					//setMyConfig(config);
					if(messages.length > selected)
						setMessage(messages[selected]);
				}
				setToken(loadedToken);
			} else {
				console.log('sign has not changed');
			}
			console.log(sign);
			console.log(displays);
		if(!loaded){
			//refresh display buttons on load (so they're not broken images)
			get_messages();
			//setTimeout(() => setLoaded(true), 150);
		}
		//}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props, displays]);


	const renderMap = (message) => {
		return utils.message.extract(message.map, size[0], size[1], rotate);
	}

	const handleSaveMessageProperties = (message) => {
		//save message properties
		console.log('updated properties', message);
		handleSend({
			vso: 'ph5_message',
			subaction: 'save',
			message : message
		}, (data) => {
			//copy message list object
			let newmsglist = Object.assign([], messageList);
			//find index of message
			let index = newmsglist.findIndex(n => n.id === message.id);
			//replace in list
			newmsglist.splice(index, 1, data.message);
			//update list
			setMessageList(newmsglist);
			
		})
	}

  	return (
    	<div className={classes.root}>
			<Grid container>
				<div className={classes.displayList}>
				<ButtonGroup orientation="vertical">
					{displays.map((msg, i) => (
						<Button
							key={i}
							variant={selected === i ? "contained" : "outlined"}
							startIcon={
								<Display 
									pixel_map={renderMap(msg)}
									width={size[0]*16}
									height={size[1]*16}
									scale={1}
								/>
							}
							onClick={(e) => {handleSelect(i)}}
						>{i+1}</Button>
					))}
				</ButtonGroup>
				</div>
    			<Canvas id={message.message} pixel_map={utils.message.extract(message.map, size[0], size[1], rotate)} height={size[1]*16} width={size[0]*16} fontSize={8} onSubmit={handleApply} size={size[0] > 10 ? 7 : size[0] > 4 ? 10 : 20}/>
			</Grid>
			<Selector width={size[0]*16} height={size[1]*16} items={messageList}
				onSelect={handleSelectMessage}
				onDelete={handleDelete}
				isAdmin={() => user.usergroup === 1}
				render={renderMap}
				onSave={handleSaveMessageProperties}
			/>
    	</div>
  );
}
